import React from 'react';
import PropTypes from 'prop-types';
import { round2Display, ratioToPercentPlus } from '../../lib/format';

const FF_FIELDS = [
  'Team',
  'GP',
  'eFG%',
  'ORR',
  'FTR',
  'TOV%',
  'USG',
  'AST%',
  'ATO',
];
const SHOOTING_FIELDS = [
  'Team',
  'GP',
  'Poss',
  'FG%',
  'FG3%',
  'FG2%',
  'FT%',
  'FG3 PAR',
  'PPS',
  'TS',
];

const AdvancedBoxscoreFourFactorsRow = ({
  season,
  stats,
  team,
  games,
  total = false,
}) => {
  const { four_factors, usage, assists } = stats.player;
  const label = season.name;

  return (
    <tr className={total ? 's-player-view__boxscore__career footer' : ''}>
      <td className="nan label double">{label}</td>
      <td className="nan team">
        <div>
          {!total && team && (
            <div>
              <img alt={`Team Logo - ${team.name}`} src={team.image} />
            </div>
          )}
          {team ? team.name_short : 'Career'}
        </div>
      </td>
      <td>{games}</td>
      <td>{ratioToPercentPlus(four_factors.efg, 1)}</td>
      <td>{ratioToPercentPlus(four_factors.orr, 1)}</td>
      <td>{ratioToPercentPlus(four_factors.ftr, 1)}</td>
      <td>{ratioToPercentPlus(four_factors.tov, 1)}</td>
      <td>{ratioToPercentPlus(usage, 1)}</td>
      <td>{ratioToPercentPlus(assists.assist_percentage, 1)}</td>
      <td>{round2Display(assists.ato, 1)}</td>
    </tr>
  );
};

const AdvancedBoxscoreShootingRow = ({
  season,
  stats,
  team,
  games,
  total = false,
}) => {
  const { shooting_efficiency, possessions } = stats.player;
  const label = season.name;

  return (
    <tr className={total ? 's-player-view__boxscore__career footer' : ''}>
      <td className="nan label double">{label}</td>
      <td className="nan team">
        <div>
          {!total && team && (
            <div>
              <img alt={`Team Logo - ${team.name}`} src={team.image} />
            </div>
          )}
          {team ? team.name_short : 'Career'}
        </div>
      </td>
      <td>{games}</td>
      <td>{Math.round(possessions)}</td>
      <td>{ratioToPercentPlus(shooting_efficiency.fg_perc, 1)}</td>
      <td>{ratioToPercentPlus(shooting_efficiency.fg3_perc, 1)}</td>
      <td>{ratioToPercentPlus(shooting_efficiency.fg2_perc, 1)}</td>
      <td>{ratioToPercentPlus(shooting_efficiency.ft_perc, 1)}</td>
      <td>{ratioToPercentPlus(shooting_efficiency.fg3_par, 1)}</td>
      <td>{round2Display(shooting_efficiency.pps_noft, 2)}</td>
      <td>{ratioToPercentPlus(shooting_efficiency.true_shooting, 1)}</td>
    </tr>
  );
};

const AdvancedBoxscoresRowWrapper = ({
  seasons,
  career,
  fields,
  RowComponent,
}) => (
  <table className="s-player-view__adv-stats collapse">
    <thead>
      <tr className="header">
        <th className="s-player-view__boxscores__season--name">Season</th>
        {fields.map(field => (
          <th key={field}>{field.toUpperCase()}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {seasons.map(season => (
        <RowComponent
          key={`${season.season.id}-${season.team.id}`}
          {...season}
        />
      ))}
      <RowComponent {...career} total={true} />
    </tbody>
  </table>
);

const PlayerAdvancedStats = ({ player }) => {
  const { stats } = player;
  const career = stats && stats[stats.length - 1];
  const seasons =
    stats &&
    stats
      .filter(season => season.season.name.toLowerCase() !== 'career')
      .sort((a, b) => a.season.start_year - b.season.start_year);

  return (
    <div className="s-player-summary__adv-stats--boxscores">
      <div className="summary-section">
        <h3>Four Factors / Usage</h3>
        <AdvancedBoxscoresRowWrapper
          seasons={seasons}
          career={career}
          fields={FF_FIELDS}
          RowComponent={AdvancedBoxscoreFourFactorsRow}
        />
      </div>
      <div className="summary-section">
        <h3>Shooting</h3>
        <AdvancedBoxscoresRowWrapper
          seasons={seasons}
          career={career}
          fields={SHOOTING_FIELDS}
          RowComponent={AdvancedBoxscoreShootingRow}
        />
      </div>
    </div>
  );
};

PlayerAdvancedStats.propTypes = {
  player: PropTypes.object.isRequired,
};

export default PlayerAdvancedStats;
